import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgProgress } from '@ngx-progressbar/core';
import { ToastrService } from 'ngx-toastr';
import { APIOperableComponent } from '../../../../shared/components/api-operable/api-operable.component';
import { ConfirmationComponent } from '../../../../shared/components/confirmation/confirmation.component';
import { ConfirmationModel } from '../../../../shared/model/confirmation.model';
import { UIDialogService } from '../../../../shared/services/ui-dialog.service';
import { AuthService } from '../../../security/service/auth.service';
import { IssueCustomerMessage } from '../../model/issue-customer-message.model';
import { IssueUIMessages } from '../../model/issue-ui.messages';
import { IssueService } from '../../service/issue.service';

@Component({
  selector: 'customer-message-details-dialog',
  templateUrl:
    'console/app-js/modules/issue/components/customer-message-details-dialog/customer-message-details-dialog.component.html'
})
export class CustomerMessageDialogComponent extends APIOperableComponent {
  public isActive = true;
  public activeStatus = 'Active';
  @Input('opened') opened = false;
  @Input('customerMessageModel') customerMessageModel: IssueCustomerMessage;
  @Input('hasCustomerMessages') hasCustomerMessages = false;
  @Output() closed = new EventEmitter<any>();
  protected messageFormVisible = false;
  public addMessage = false;
  protected today = new Date(
    new Date().toLocaleDateString('en-US', { timeZone: 'America/New_York' })
  );
  protected disableSaveButton = true;
  protected isEdited = false;

  protected messageType = [
    {
      id: 'serviceRequestCreation',
      value: 'Service Request Creation'
    }
  ];

  protected defaultMessageType = this.messageType[0];
  protected id: string;

  constructor(
    private dialogService: UIDialogService,
    progressService: NgProgress,
    toastr: ToastrService,
    authService: AuthService,
    private issueService: IssueService
  ) {
    super(progressService, toastr, authService);
  }

  ngOnChanges(): void {
    if (
      this.customerMessageModel &&
      (this.customerMessageModel.startDate === undefined ||
        this.customerMessageModel.startDate === 'Not Set')
    ) {
      this.customerMessageModel.startDate = this.today;
    }
  }

  checkValidation() {
    let valid = [];
    if (
      this.customerMessageModel.messageText === undefined ||
      this.customerMessageModel.messageText.length === 0 ||
      this.customerMessageModel.messageText.length > 255
    ) {
      valid.push('length');
    }
    if (this.validateDatesCheck()) {
      valid.push('date');
    }
    if (valid.length > 0) {
      this.disableSaveButton = true;
    } else {
      this.disableSaveButton = false;
    }
  }

  validateDatesCheck() {
    return (
      this.customerMessageModel.startDate !== undefined &&
      this.customerMessageModel.startDate !== null &&
      this.customerMessageModel.endDate !== undefined &&
      this.customerMessageModel.endDate !== null &&
      this.customerMessageModel.startDate >=
        this.customerMessageModel.endDate &&
      this.customerMessageModel.startDate < new Date()
    );
  }

  public close() {
    this.messageFormVisible = false;
    this.disableSaveButton = true;
    this.closed.emit(this.isEdited);
    this.isEdited = false;
  }

  public toggleForm(addMessage) {
    this.addMessage = addMessage;
    if (this.customerMessageModel.startDate !== undefined) {
      this.customerMessageModel.startDate = new Date(
        this.customerMessageModel.startDate
      );
    }
    if (this.customerMessageModel.endDate !== undefined) {
      this.customerMessageModel.endDate = new Date(
        this.customerMessageModel.endDate
      );
    }
    this.messageFormVisible = !this.messageFormVisible;
    this.checkValidation();
  }

  public open() {
    this.opened = true;
  }

  onDeleteMessage(): void {
    if (this.hasCustomerMessages) {
      this.customerMessageModel.endDate = new Date(
        new Date().toLocaleString('en-US', { timeZone: 'America/New_York' })
      );
      this.startProgress();
      this.customerMessageModel.id = this.customerMessageModel.id || this.id;
      this.issueService.putMessage(this.customerMessageModel).subscribe(
        result => {
          if (result.responseCode === 200) {
            this.finishProgress();
            this.onAPISuccess(IssueUIMessages.DELETE_MESSAGE_SUCCESS);
            this.isEdited = true;
            this.hasCustomerMessages = false;
            this.close();
          } else {
            this.finishProgress();
            this.onAPIError(IssueUIMessages.DELETE_MESSAGE_ERROR);
          }
        },
        () => {
          this.onAPIError(IssueUIMessages.DELETE_MESSAGE_ERROR);
        }
      );
    }
  }

  openDeleteDialog() {
    this.dialogService
      .open(ConfirmationComponent, [
        {
          provide: ConfirmationModel,
          useValue: new ConfirmationModel(
            IssueUIMessages.DELETE_MESSAGE_TITLE,
            IssueUIMessages.DELETE_MESSAGE_CONFIRMATION
          )
        }
      ])
      .then(confirmed => {
        if (confirmed) {
          this.onDeleteMessage();
        }
      });
  }

  public submit() {
    if (!this.disableSaveButton) {
      this.startProgress();
      if (this.addMessage) {
        this.customerMessageModel.messageDisplayType = this.defaultMessageType.id;

        this.issueService.postMessage(this.customerMessageModel).subscribe(
          res => {
            if (res.responseCode === 200) {
              this.id = res.results.id;
              this.onAPISuccess(IssueUIMessages.UPDATE_ISSUE_SUCCESS);
            } else {
              this.onAPIError(IssueUIMessages.UPDATE_ISSUE_ERROR);
            }
          },
          err => {
            this.onAPIError(IssueUIMessages.UPDATE_ISSUE_ERROR);
          }
        );
      } else {
        this.customerMessageModel.id = this.customerMessageModel.id || this.id;
        this.customerMessageModel.messageDisplayType = this.defaultMessageType.id;
        this.issueService.putMessage(this.customerMessageModel).subscribe(
          res => {
            if (res.result && res.status === 'Completed') {
              res = res.result;
            }
            if (res.responseCode === 200) {
              this.onAPISuccess(IssueUIMessages.UPDATE_ISSUE_SUCCESS);
            } else {
              this.onAPIError(IssueUIMessages.UPDATE_ISSUE_ERROR);
            }
          },
          err => {
            this.onAPIError(IssueUIMessages.UPDATE_ISSUE_ERROR);
          }
        );
      }
      this.isEdited = true;
      this.hasCustomerMessages = true;
      this.messageFormVisible = false;
      this.disableSaveButton = true;
      this.finishProgress();
    }
  }

  updateMessage(value: string) {
    this.customerMessageModel.messageText = value;
    this.checkValidation();
  }

  updateStartDate(event) {
    if (event !== null) {
      this.customerMessageModel.startDate = event;
    } else {
      this.customerMessageModel.startDate = undefined;
    }
    this.checkValidation();
  }

  updateEndDate(event) {
    if (event !== null) {
      this.customerMessageModel.endDate = event;
    } else {
      this.customerMessageModel.endDate = undefined;
    }
    this.checkValidation();
  }

  valueChanged(value: Boolean): void {
    if (value) {
      this.isActive = false;
      this.activeStatus = 'Inactive';
    } else {
      this.isActive = true;
      this.activeStatus = 'Active';
    }
  }
}
